module.exports = __webpack_public_path__ + "static/img/logo.9f33a59d.png";